import dayjs from '@common/utils/dayjs';
import { SELECT_NETWORK } from '../../network/actions';
import { FLEXCHANGE_RECEIVE_EXCHANGE } from '../actions';

const initialState = {
  currentWeek: dayjs().startOf('isoweek'),
  search: { team: null, status: null },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FLEXCHANGE_RECEIVE_EXCHANGE:
      return { ...state, currentWeek: dayjs(action.exchange.source.date).startOf('isoweek') };
    case SELECT_NETWORK: return initialState;
    default: return state;
  }
};
